<customerdocument-menu (outputDownload)="downloadCustomerDocumentFiltered()" (onReload)="onReload()"></customerdocument-menu>
<h2>{{title}} for {{defaults.tenant}}</h2>

<customerdocument-filter (outputFilter)="getFilteredCustomerDocumentsByTenant()"></customerdocument-filter>
<customerdocument-list [list]="list" [showLocalFilter]="showLocalFilter"></customerdocument-list>